import { render, staticRenderFns } from "./errorDiv.vue?vue&type=template&id=168138a7&scoped=true&"
import script from "./errorDiv.vue?vue&type=script&lang=js&"
export * from "./errorDiv.vue?vue&type=script&lang=js&"
import style0 from "./errorDiv.vue?vue&type=style&index=0&id=168138a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168138a7",
  null
  
)

export default component.exports